import cardAdapterMap from './cardAdapterMap';
import groupAdapterMap from './groupAdapterMap';
import { TileAdapterMap } from './types';

const adapterMap: TileAdapterMap = {
  ...cardAdapterMap,
  ...groupAdapterMap,
};

export default adapterMap;
